module.exports = __webpack_public_path__ + "img/contract.3ddb605c.png";